import React, { useEffect, useMemo, useState } from "react";
import { Box, Paper, Typography, Divider } from "@material-ui/core";
import BranchSelect from "../../Components/BranchSelect";
import DateRangeBar from "../../Components/DateRangeBar";
import ExportButtons from "../../Components/ExportButtons";
import DataTable from "../../Components/DataTable";
import { Api } from "../../api/client";
import { money, num } from "../../utils/format";
import { todayISO, daysAgoISO } from "./_date";

export default function CancelacionesDevoluciones(){
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchId] = useState("");
  const [range, setRange] = useState({ from: daysAgoISO(30), to: todayISO() });

  const [info, setInfo] = useState(null);

  const params = useMemo(()=>({
    from: range.from, to: range.to, branch: branchId
  }), [range, branchId]);

  useEffect(()=>{
    Api.branches().then(res => setBranches(res.data))
      .catch(()=> setBranches([{id:"", nombre:"Todas"}]));
  }, []);

  useEffect(()=>{
    async function load(){
      try{
        const r = await Api.cancellations(params);
        setInfo(r);
      }catch(e){
        console.error(e);
        setInfo(null);
      }
    }
    load();
  }, [params]);

  const columns = [
    { key:"fecha", label:"Fecha" },
    { key:"tipo", label:"Tipo" },
    { key:"sucursalOrigen", label:"Origen" },
    { key:"sucursalDestino", label:"Destino" },
    { key:"monto", label:"Monto", render:r=>money(r.monto) },
    { key:"motivo", label:"Motivo" },
  ];

  return (
    <Paper style={{padding:18, borderRadius:14}}>
      <Typography variant="h6" style={{fontWeight:900}}>Cancelaciones y devoluciones</Typography>
      <Divider style={{margin:"12px 0"}}/>

      <Box display="flex" gridGap={12} flexWrap="wrap">
        <BranchSelect value={branchId} options={branches} onChange={setBranchId}/>
        <DateRangeBar from={range.from} to={range.to} onChange={setRange}/>
        <ExportButtons filename={`cancelaciones_${params.from}_a_${params.to}.csv`} rows={info ? (info.detalle||[]) : []}/>
      </Box>

      {info && info.resumen ? (
        <Box mt={2} display="flex" gridGap={18} flexWrap="wrap" style={{fontSize:13}}>
          <div><b>Cancelaciones:</b> {num(info.resumen.cancelaciones)}</div>
          <div><b>Devoluciones:</b> {num(info.resumen.devoluciones)}</div>
          <div><b>Cambios de sucursal:</b> {num(info.resumen.cambiosSucursal)}</div>
        </Box>
      ) : null}

      <Box mt={2}>
        <DataTable columns={columns} rows={info ? (info.detalle||[]) : []}/>
      </Box>
    </Paper>
  );
}